import React from "react";

import { SortAscIcon, SortDescIcon, NoSortIcon } from "../SVGIcons";

const SortOrder = {
  NONE: "none",
  ASC: "asc",
  DESC: "desc",
} as const;

type SortOrderType = (typeof SortOrder)[keyof typeof SortOrder];

interface SortableTableHeaderProps<T extends string> {
  label: string;
  field: T;
  currentField: T | null;
  currentOrder: SortOrderType;
  onSort: (field: T) => void; // eslint-disable-line no-unused-vars
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

function SortableTableHeader<T extends string>({
  label,
  field,
  currentField,
  currentOrder,
  onSort,
  icon,
  style,
}: SortableTableHeaderProps<T>) {
  const isActive = currentField === field;
  const showNoSort = !isActive || currentOrder === SortOrder.NONE;
  const showAsc = isActive && currentOrder === SortOrder.ASC;
  const showDesc = isActive && currentOrder === SortOrder.DESC;

  return (
    <th
      className="px-3 py-2 text-center text-white border border-[#889bc5] whitespace-nowrap"
      style={style}
    >
      <div className="flex gap-1 items-center w-full justify-center">
        <span>{label}</span>
        {icon}
        {showNoSort && <NoSortIcon onClick={() => onSort(field)} />}
        {showAsc && <SortAscIcon onClick={() => onSort(field)} />}
        {showDesc && <SortDescIcon onClick={() => onSort(field)} />}
      </div>
    </th>
  );
}

export default SortableTableHeader;
